import { useEffect, useState } from 'react';

import {
  isMaintenanceBypassEnabled,
  subscribeMaintenanceBypass,
} from './maintenanceBypass';

export function useMaintenanceBypass(): boolean {
  const [enabled, setEnabled] = useState(isMaintenanceBypassEnabled());

  useEffect(() => subscribeMaintenanceBypass(setEnabled), []);

  return enabled;
}
